// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__DnUO2","requiredAsterisk":"Info_requiredAsterisk__Dj7mi"};